import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import { getValidCartItems } from '../../../utils/cart';

const selectAutoCombo = (state: RootState) => state.autoCombo;
const selectAutoComboCartItems = createSelector(
  selectAutoCombo,
  (state) => state.autoCombinedCartItems
);

const selectAutoComboCartItemsQuantity = createSelector(
  selectAutoCombo,
  (state) => state.autoCombinedCartItemsQuantity
);

const selectLastNonAutoCombinedCartItemId = createSelector(
  selectAutoCombo,
  (state) => {
    // HITL-1282: guard against an undefined autoCombinedCartItems slice and
    // return undefined when there is no preceding non-auto-combined item
    // (findIndex returning -1 or 0 used to underflow into items[-1].cartItemId
    // and throw "Cannot read properties of undefined").
    const items = Object.values(state.autoCombinedCartItems ?? {});
    const firstAutoCombinedCartItemIdx = items.findIndex(
      (item) =>
        item.autoCombinedCartItemIds && item.autoCombinedCartItemIds.length > 0
    );
    if (firstAutoCombinedCartItemIdx <= 0) return undefined;
    return items[firstAutoCombinedCartItemIdx - 1].cartItemId;
  }
);

const selectValidAutoComboCartItems = createSelector(
  selectAutoComboCartItems,
  (autoComboCartItems) => getValidCartItems(autoComboCartItems)
);

export {
  selectAutoComboCartItems,
  selectAutoComboCartItemsQuantity,
  selectValidAutoComboCartItems,
  selectLastNonAutoCombinedCartItemId,
};
